module.exports = __webpack_public_path__ + "static/default-ad38f46f2321b71004058b4a0863d994.png";